/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type RequestShippingQuoteForm_user$ref = any;
type RequestShippingQuoteForm_viewer$ref = any;
type RequestShippingSuccessContent_seller$ref = any;
type ShippingDetailsContainer_viewer$ref = any;
export type RequestShippingQuoteModal_viewer$ref = any;
export type RequestShippingQuoteModal_viewer = {
    readonly onlyTradeRequestsQuote: boolean | null;
    readonly user?: {
        readonly id: string;
        readonly isVerifiedTrade: boolean | null;
        readonly " $fragmentRefs": RequestShippingQuoteForm_user$ref;
    } | null;
    readonly relevantShippingInfo?: {
        readonly shipmentQuote: {
            readonly subTotalAmount: {
                readonly amount: number | null;
            } | null;
            readonly isCustom: boolean | null;
        } | null;
    } | null;
    readonly item?: {
        readonly title: string | null;
        readonly isSold: boolean | null;
        readonly seller: {
            readonly serviceId: string | null;
            readonly " $fragmentRefs": RequestShippingSuccessContent_seller$ref;
        } | null;
        readonly hasPreQuotedShipping: boolean | null;
        readonly itemIsOnHold: boolean | null;
    } | null;
    readonly buyerItemConversation?: {
        readonly id: string;
        readonly serviceId: string | null;
    } | null;
    readonly transactions?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly serviceId: string | null;
                readonly isCanceled: boolean | null;
                readonly hasCompletedCheckout: boolean | null;
                readonly lastShipmentQuote: {
                    readonly status: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly conversation?: {
        readonly transaction: {
            readonly id: string;
            readonly serviceId: string | null;
            readonly isCanceled: boolean | null;
            readonly hasCompletedCheckout: boolean | null;
        } | null;
        readonly originalBuyer: {
            readonly user: {
                readonly " $fragmentRefs": RequestShippingQuoteForm_user$ref;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": ShippingDetailsContainer_viewer$ref & RequestShippingQuoteForm_viewer$ref;
    readonly " $refType": RequestShippingQuoteModal_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "FragmentSpread",
        "name": "RequestShippingQuoteForm_user",
        "args": null
    } as any), v2 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any), v3 = ({
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
    } as any), v4 = [
        (v2 /*: any*/),
        (v3 /*: any*/)
    ], v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCanceled",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasCompletedCheckout",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "RequestShippingQuoteModal_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "itemId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "shouldFetchItem",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "shouldFetchConversation",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "itemIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "shouldFetchTransaction",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "conversationId",
                "type": "ID!"
            },
            {
                "kind": "RootArgument",
                "name": "hasConversationId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": "onlyTradeRequestsQuote",
                "name": "isEnabled",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "useOldPdpShippingModals"
                    }
                ],
                "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                            }
                        ],
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVerifiedTrade",
                                "args": null,
                                "storageKey": null
                            },
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "relevantShippingInfo",
                        "storageKey": null,
                        "args": (v4 /*: any*/),
                        "concreteType": "QueryRelevantShippingInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "shipmentQuote",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ShipmentQuote",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "subTotalAmount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "amount",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isCustom",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "shouldFetchItem",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": [
                            (v3 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "SHIPPING_MODAL"
                            }
                        ],
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "title",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isSold",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "seller",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Seller",
                                "plural": false,
                                "selections": [
                                    (v5 /*: any*/),
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "RequestShippingSuccessContent_seller",
                                        "args": null
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasPreQuotedShipping",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "itemIsOnHold",
                                "name": "isOnHold",
                                "args": [
                                    (v2 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "shouldFetchConversation",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerItemConversation",
                        "storageKey": null,
                        "args": (v4 /*: any*/),
                        "concreteType": "Conversation",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v5 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "shouldFetchTransaction",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transactions",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "buyerId",
                                "variableName": "userIds"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            },
                            {
                                "kind": "Variable",
                                "name": "itemId",
                                "variableName": "itemIds"
                            },
                            {
                                "kind": "Literal",
                                "name": "sort",
                                "value": "createdDate desc"
                            },
                            {
                                "kind": "Literal",
                                "name": "viewName",
                                "value": "mc.conversationTransaction"
                            }
                        ],
                        "concreteType": "TransactionConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TransactionEdge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Transaction",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            (v7 /*: any*/),
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "lastShipmentQuote",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ShipmentQuote",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "status",
                                                        "args": null,
                                                        "storageKey": null
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasConversationId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "conversation",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "conversationId",
                                "variableName": "conversationId"
                            }
                        ],
                        "concreteType": "Conversation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "transaction",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v5 /*: any*/),
                                    (v6 /*: any*/),
                                    (v7 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "originalBuyer",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "user",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ShippingDetailsContainer_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "RequestShippingQuoteForm_viewer",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '6ec5992c6aac685403081ea3acdcb28b';
export default node;
